"use client"

import { useAppSelector } from "@/hooks/redux"
import { Button, ButtonProps, ConfigProvider } from "antd"

const ProductSizeButton = (props: ButtonProps) => {
  const sizesSelectionSetting = useAppSelector(state => state.store.store_setting.data.sizes_selection)

  const selectedStyle = {
    color: sizesSelectionSetting.selected.color,
    borderColor: sizesSelectionSetting.selected.border_color,
    borderWidth: sizesSelectionSetting.selected.border_width,
    backgroundColor: sizesSelectionSetting.selected.bg_color,
    outlineColor: sizesSelectionSetting.selected.bg_color,
  }

  const unselectedStyle = {
    color: sizesSelectionSetting.unselected.color,
    borderColor: sizesSelectionSetting.unselected.border_color,
    borderWidth: sizesSelectionSetting.unselected.border_width,
    backgroundColor: sizesSelectionSetting.unselected.bg_color || 'transparent',
    outlineColor: sizesSelectionSetting.unselected.bg_color,
  }

  return (
    <Button
      {...props}
      htmlType="button"
      style={{
        minHeight: `${sizesSelectionSetting.height / 10}rem`,
        minWidth: `${sizesSelectionSetting.width / 10}rem`,
        fontSize: `${sizesSelectionSetting.size / 10}rem`,
        fontFamily: !!sizesSelectionSetting.font_name ? `${sizesSelectionSetting.font_name} !important` : undefined,
        ...(sizesSelectionSetting.decorator === 'bold' ? {
          fontWeight: 'bold'
        } : {}),
        ...(sizesSelectionSetting.decorator === 'italic' ? {
          fontStyle: 'italic'
        } : {}),
        ...(sizesSelectionSetting.decorator === 'underline' ? {
          textDecoration: 'underline'
        } : {}),
        ...(!props.ghost ? selectedStyle : unselectedStyle),
        ...props.style,
        boxShadow: 'none'
      }}
      ghost={false}
      type="primary"
      size="large"
    />
  )
}

export default ProductSizeButton